import React from 'react';

const Notification = () => <h1>Notification</h1>;

export default Notification;
